import { finish, error } from '../../../modules/customers/actions/get-transactions';

import api from '../../../api';

export function request(dispatch, { id, name, conditions }) {
    api.get('/customers/' + id + '/transactions', conditions, { cache: true }).then(
        ({ transactions }) => dispatch(finish(id, name, transactions)),
        ({ errors }) => dispatch(error(id, name, errors))
    );
}
